module.exports = __webpack_public_path__ + "img/viagem-dubai-carro.3fd8b437.jpeg";